module.exports = __webpack_public_path__ + "static/media/cuenta@2x.ec94458c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/datos/cuenta@2x.jpg
// module id = 562
// module chunks = 0